const italian = {
  'seo.title': 'Make me a Gift',
  'seo.description': 'Le sorprese sono belle... ma se poi non ti piace?! Crea la tua lista dei desideri online con Make me a Gift!',
  'hero.title.first': 'Da oggi nessun regalo',
  'hero.title.second': 'finisce nel dimenticatoio',
  'hero.description': 'Le sorprese sono belle... ma se poi non ti piace? Crea la tua wishlist, aggiungi quello che desideri davvero e condividila con amici e familiari. Loro non devono più scervellarsi e tu non ci resti male.',
  'hero.followup': 'La prossima volta che ti chiedono "cosa vuoi?", avrai già la risposta pronta.',
  'hero.start': 'Inizia gratis',
  'hero.learn': 'Scopri di più',
  'steps.heading': 'Come funziona',
  'steps.description': 'Tre passi e la tua lista è pronta per essere condivisa.',
  'steps.badge': 'Passo',
  'steps.one.title': 'Registrati in un click',
  'steps.one.text': "Ti serve solo un'email e uno username. Il tuo link pubblico è subito pronto da condividere.",
  'steps.two.title': 'Aggiungi desideri',
  'steps.two.text': 'Incolla un link e la foto arriva da sola, oppure carica tutto a mano: titolo, prezzo, taglia e categoria.',
  'steps.three.title': 'Condividi il tuo link',
  'steps.three.text': 'Chi riceve il link vede la tua lista e può scegliere un regalo da farti. Non serve nemmeno registrarsi.',
  'donations.heading': 'Non solo oggetti',
  'donations.description': 'A volte il regalo migliore è un piccolo contributo. Con il salvadanaio integrato, chi visita la tua wishlist può farti una donazione con PayPal o altri servizi, anche senza scegliere un oggetto dalla lista.',
  'donations.one.title': 'Configura in un click',
  'donations.one.text': 'Inserisci la tua email PayPal o un link di donazione (PayPal.me, Ko-fi, etc...) e il pulsante appare automaticamente sulla tua wishlist pubblica.',
  'donations.two.title': 'Un salvadanaio digitale',
  'donations.two.text': 'Chi non vuole acquistare dalla lista può effettuare una donazione.',
  'donations.three.title': 'Per ogni occasione',
  'donations.three.text': 'Compleanni, matrimoni, lauree, nascite: chi non sa cosa regalare può comunque partecipare con un piccolo contributo, senza imbarazzo.',
  'donations.cta.text': 'Attiva il salvadanaio dal tuo pannello di controllo e aggiungi un messaggio personalizzato per invitare chi ti vuole bene a contribuire.',
  'common.createWishlist': 'Crea la tua wishlist',
  'features.categories': 'Gestisci categorie',
  'features.automatic': 'Generazione automatica',
  'features.donations': 'Ricevi donazioni',
  'features.share': 'Condividi bacheca',
  'features.screenshot': 'Screenshot',
  'why.heading': 'A nessuno piacciono i regali sbagliati.',
  'why.description': "Basta con l'arte di indovinare a caso. Crea la tua wishlist, aggiungi i tuoi desideri con un link e condividila con chi ti vuole bene",
  'footer.description': 'Crea la tua wishlist, condividila con chi ti vuole bene e ricevi i regali giusti.',
  'footer.terms': 'Termini',
  'footer.support.heading': 'Supporta il progetto',
  'footer.support.text': 'Make me a Gift è gratuito. Per mantenere il servizio attivo, offrimi un caffè con Ko-Fi.',
  'footer.support.button': 'Offrimi un caffè',
  'footer.madeWith': 'Fatto con passione, con',
  'footer.idea': "Progetto nato da un'idea di",
  'footer.login': 'Accedi',
  'footer.register': 'Registrati',
  'footer.rights': 'Tutti i diritti riservati.',
  'badge.label': 'Sito realizzato con Coderblock',
  'nav.logoAria': 'Make me a Gift home',
  'nav.home': 'Home',
  'nav.discover': 'Scopri',
  'nav.donations': 'Donazioni',
  'nav.community': 'Esplora',
  'nav.about': 'About',
  'nav.dashboard': 'Dashboard',
  'nav.logout': 'Logout',
  'nav.exit': 'Esci',
  'nav.connect': 'Collegati',
  'nav.login': 'Login',
  'nav.create': 'Crea la tua Wishlist',
  'nav.createShort': 'Crea Wishlist',
  'nav.account': 'Hai già un account?',
  'nav.openMenu': 'Apri menu',
  'nav.closeMenu': 'Chiudi menu',
  'nav.language': 'Lingua',
  'dash.hello': 'Ciao',
  'dash.subtitle': 'Gestisci i tuoi desideri e condividi il link con chi vuole farti un regalo.',
  'dash.totalWishes': 'Desideri totali',
  'dash.views': 'Visualizzazioni',
  'dash.reserved': 'Già prenotati',
  'dash.likes': 'Mi piace',
  'dash.publicLink': 'Link pubblico',
  'dash.copyLink': 'Copia link pubblico',
  'dash.editUsername': 'Modifica username (una sola volta)',
  'dash.chooseUsername': 'Scegli il tuo @username pubblico',
  'dash.usernameHint': 'Lo username si può modificare una sola volta: sceglilo con cura!',
  'dash.usernameTaken': '@{val} è già stato preso da un altro utente. Prova con un altro nome!',
  'dash.usernameChanged': 'Hai già modificato lo username in passato: non puoi più cambiarlo.',
  'dash.usernameInUse': 'Questo username è già in uso, provane un altro.',
  'dash.save': 'Salva',
  'dash.cancel': 'Annulla',
  'dash.displayNamePlaceholder': 'Il tuo nome pubblico',
  'dash.editDisplayName': 'Modifica il tuo nome pubblico',
  'dash.addWish': 'Aggiungi desiderio',
  'dash.publicPreview': 'Anteprima pubblica',
  'dash.profile': 'Profilo',
  'dash.privateHint': 'Wishlist privata — clicca per renderla pubblica',
  'dash.publicHint': 'Wishlist pubblica — clicca per renderla privata',
  'dash.piggyBank': 'Salvadanaio',
  'dash.logout': 'Esci',
  'dash.changeAvatar': 'Cambia avatar',
  'dash.manageBoards': 'Gestisci bacheche',
  'dash.manageCategories': 'Gestisci categorie',
  'dash.createCategories': 'Crea le tue categorie',
  'dash.noItemsInCategory': 'Nessun desiderio in questa categoria.',
  'dash.recurringMobile': 'Acquisto ricorrente',
  'dash.recurringDesktop': 'Consentito acquisto ricorrente',
  'dash.giftFrom': 'Un regalo di',
  'dash.shop': 'Negozio',
  'dash.delete': 'Elimina?',
  'dash.unblockItem': 'Sblocca oggetto',
  'dash.edit': 'Modifica',
  'dash.confirmDelete': 'Elimina',
  'dash.changeCover': 'Cambia',
  'dash.coverSizeHint': 'Consigliato: 1600 × 900 px (min 1200 × 675)',
  'dash.remove': 'Rimuovi',
  'dash.uploading': 'Caricamento...',
  'dash.addCover': 'Aggiungi una cover alla wishlist',
  'dash.defaultWishlistTitle': 'La mia wishlist',
  'boards.kind.wishlist': 'Wishlist classica',
  'boards.kind.guide': 'Consigli per gli acquisti',
  'boards.kind.wishlist.desc': 'Lista di desideri: chi visita può prenotare un regalo per te.',
  'boards.kind.guide.desc': 'Per consigliare alla community gli articoli che preferisci.',
  'boards.new.title': 'Nuova bacheca',
  'boards.new.chooseKind': 'Che tipo di bacheca vuoi creare?',
  'boards.new.namePlaceholder': 'Nome della bacheca',
  'boards.new.create': 'Crea',
  'boards.icon.wishlist': 'Wishlist classica',
  'boards.icon.guide': 'Consigli per gli acquisti',
  'boards.manager.title': 'Le tue bacheche',
  'boards.manager.kind': 'Tipo di bacheca',
  'boards.manager.privateHint': 'Privata — clicca per renderla pubblica',
  'boards.manager.publicHint': 'Pubblica — clicca per renderla privata',
  'boards.manager.confirmDelete': 'Elimina?',
  'boards.manager.cancel': 'No',
  'boards.manager.deleteTitle': 'Elimina bacheca (con tutti i suoi oggetti)',
  'boards.manager.minBoards': 'Devi avere almeno una bacheca',
  'boards.manager.namePlaceholder': 'Nome nuova bacheca…',
  'boards.manager.create': 'Nuova',
  'boards.icon.private': 'Privata',
  'boards.icon.public': 'Pubblica',
  'guide.badge': 'Consigli',
  'guide.goToStore': 'Vai al negozio',
  'guide.itemsHeading': 'Consigliati',
  'boardsSection.heading': 'Non solo wishlist',
  'boardsSection.description': 'Oltre alla classica lista dei desideri, puoi creare anche bacheche dedicate ai consigli per gli acquisti: due modi diversi di condividere, per ogni occasione.',
  'boardsSection.wishlist.badge': 'Per ricevere regali',
  'boardsSection.wishlist.text': 'Incolla un link e reperisci in automatico le foto e le informazioni relative, oppure inseriscile manualmente. Chi accede alla tua lista può scegliere un regalo da farti. Non occorre nemmeno registrarsi.',
  'boardsSection.guide.badge': 'Per consigliare',
  'boardsSection.guide.text': 'Crea una bacheca di consigli per gli acquisti: suggerisci i tuoi prodotti preferiti alla community. Ogni scheda rimanda direttamente al negozio, e chi visita può lasciare un "mi piace" sui prodotti che gli piacciono di più.',
  'boardsSection.cta': 'Crea la tua bacheca',
} as const

export type TranslationKey = keyof typeof italian

const english: Record<TranslationKey, string> = {
  'seo.title': 'Make me a Gift',
  'seo.description': "Surprises are wonderful... but what if you don't like them?! Create your online wish list with Make me a Gift!",
  'hero.title.first': 'From now on, no gift',
  'hero.title.second': 'will be forgotten',
  'hero.description': "Surprises are wonderful... but what if you don't like them? Create your wishlist, add what you truly want and share it with friends and family. They no longer have to rack their brains, and you won't be disappointed.",
  'hero.followup': 'The next time someone asks “what do you want?”, your answer will already be ready.',
  'hero.start': 'Start for free',
  'hero.learn': 'Learn more',
  'steps.heading': 'How it works',
  'steps.description': 'Three steps and your list is ready to share.',
  'steps.badge': 'Step',
  'steps.one.title': 'Sign up',
  'steps.one.text': 'All you need is an email and a username. Your public link is immediately ready to share.',
  'steps.two.title': 'Add wishes',
  'steps.two.text': 'Paste a link and the photo appears automatically, or add everything manually.',
  'steps.three.title': 'Share your link',
  'steps.three.text': "Anyone who receives the link can view your list and choose a gift for you. They don't even need to sign up.",
  'donations.heading': 'More than just objects',
  'donations.description': 'Sometimes the best gift is a small contribution. With the built-in money box, visitors to your wishlist can send you a donation through PayPal or other services, without choosing an item from the list.',
  'donations.one.title': 'Set it up in one click',
  'donations.one.text': 'Enter your PayPal email or a donation link (PayPal.me, Ko-fi, etc...) and the button automatically appears on your public wishlist.',
  'donations.two.title': 'A digital money box',
  'donations.two.text': 'Anyone who prefers not to buy from the list can make a donation.',
  'donations.three.title': 'For every occasion',
  'donations.three.text': 'Birthdays, weddings, graduations, new babies: anyone unsure what to give can still join in with a small contribution, without embarrassment.',
  'donations.cta.text': 'Enable the money box from your dashboard and add a personal message inviting the people who care about you to contribute.',
  'common.createWishlist': 'Create your wishlist',
  'features.categories': 'Manage categories',
  'features.automatic': 'Automatic generation',
  'features.donations': 'Receive donations',
  'features.share': 'Share your board',
  'features.screenshot': 'Screenshot',
  'why.heading': 'Nobody likes the wrong gifts.',
  'why.description': 'No more random guessing. Create your wishlist, add your wishes with a link and share it with the people who care about you',
  'footer.description': 'Create your wishlist, share it with the people who care about you and receive the right gifts.',
  'footer.terms': 'Terms',
  'footer.support.heading': 'Support the project',
  'footer.support.text': 'Make me a Gift is free. Help keep the service running by buying me a coffee on Ko-Fi.',
  'footer.support.button': 'Buy me a coffee',
  'footer.madeWith': 'Made with passion, with',
  'footer.idea': 'A project based on an idea by',
  'footer.login': 'Sign in',
  'footer.register': 'Sign up',
  'footer.rights': 'All rights reserved.',
  'badge.label': 'Website made with Coderblock',
  'nav.logoAria': 'Make me a Gift home',
  'nav.home': 'Home',
  'nav.discover': 'Discover',
  'nav.donations': 'Donations',
  'nav.community': 'Explore',
  'nav.about': 'About',
  'nav.dashboard': 'Dashboard',
  'nav.logout': 'Logout',
  'nav.exit': 'Sign out',
  'nav.connect': 'Sign in',
  'nav.login': 'Login',
  'nav.create': 'Create your Wishlist',
  'nav.createShort': 'Create Wishlist',
  'nav.account': 'Already have an account?',
  'nav.openMenu': 'Open menu',
  'nav.closeMenu': 'Close menu',
  'nav.language': 'Language',
  'dash.hello': 'Hi',
  'dash.subtitle': 'Manage your wishes and share the link with whoever wants to give you a gift.',
  'dash.totalWishes': 'Articles',
  'dash.views': 'Views',
  'dash.reserved': 'Reserved',
  'dash.likes': 'Likes',
  'dash.publicLink': 'Public link',
  'dash.copyLink': 'Copy public link',
  'dash.editUsername': 'Edit username (one time only)',
  'dash.chooseUsername': 'Choose your public @username',
  'dash.usernameHint': 'The username can only be changed once: choose it carefully!',
  'dash.usernameTaken': '@{val} is already taken by another user. Try a different name!',
  'dash.usernameChanged': 'You have already changed your username in the past: you cannot change it again.',
  'dash.usernameInUse': 'This username is already in use, try another one.',
  'dash.save': 'Save',
  'dash.cancel': 'Cancel',
  'dash.displayNamePlaceholder': 'Your public name',
  'dash.editDisplayName': 'Edit your public name',
  'dash.addWish': 'Add wish',
  'dash.publicPreview': 'Public preview',
  'dash.profile': 'Profile',
  'dash.privateHint': 'Private wishlist — click to make it public',
  'dash.publicHint': 'Public wishlist — click to make it private',
  'dash.piggyBank': 'Piggy bank',
  'dash.logout': 'Sign out',
  'dash.changeAvatar': 'Change avatar',
  'dash.manageBoards': 'Manage boards',
  'dash.manageCategories': 'Manage categories',
  'dash.createCategories': 'Create your categories',
  'dash.noItemsInCategory': 'No wishes in this category.',
  'dash.recurringMobile': 'Recurring purchase',
  'dash.recurringDesktop': 'Recurring purchase allowed',
  'dash.giftFrom': 'A gift from',
  'dash.shop': 'Shop',
  'dash.delete': 'Delete?',
  'dash.unblockItem': 'Unblock item',
  'dash.edit': 'Edit',
  'dash.confirmDelete': 'Delete',
  'dash.changeCover': 'Change',
  'dash.coverSizeHint': 'Recommended: 1600 × 900 px (min 1200 × 675)',
  'dash.remove': 'Remove',
  'dash.uploading': 'Uploading...',
  'dash.addCover': 'Add a cover to your wishlist',
  'dash.defaultWishlistTitle': 'My wishlist',
  'boards.kind.wishlist': 'Classic wishlist',
  'boards.kind.guide': 'Shopping advice',
  'boards.kind.wishlist.desc': 'A list of wishes: visitors can reserve a gift for you.',
  'boards.kind.guide.desc': 'To showcase the products you love the most!',
  'boards.new.title': 'New board',
  'boards.new.chooseKind': 'What kind of board do you want to create?',
  'boards.new.namePlaceholder': 'Board name',
  'boards.new.create': 'Create',
  'boards.icon.wishlist': 'Classic wishlist',
  'boards.icon.guide': 'Shopping advice',
  'boards.manager.title': 'Your boards',
  'boards.manager.kind': 'Board type',
  'boards.manager.privateHint': 'Private — click to make it public',
  'boards.manager.publicHint': 'Public — click to make it private',
  'boards.manager.confirmDelete': 'Delete?',
  'boards.manager.cancel': 'No',
  'boards.manager.deleteTitle': 'Delete board (with all its items)',
  'boards.manager.minBoards': 'You must have at least one board',
  'boards.manager.namePlaceholder': 'New board name…',
  'boards.manager.create': 'New',
  'boards.icon.private': 'Private',
  'boards.icon.public': 'Public',
  'guide.badge': 'Advice',
  'guide.goToStore': 'Go to store',
  'guide.itemsHeading': 'Recommended',
  'boardsSection.heading': 'Not just wishlists',
  'boardsSection.description': "Alongside the classic wish list, you can also create boards dedicated to shopping advice: two different ways to share, for every occasion.",
  'boardsSection.wishlist.badge': 'For receiving gifts',
  'boardsSection.wishlist.text': 'Paste a link and the photos and details are fetched automatically, or add them manually. Anyone who opens your list can choose a gift for you. No sign-up needed.',
  'boardsSection.guide.badge': 'For recommending',
  'boardsSection.guide.text': 'Create a shopping advice board: suggest your favourite products to the community. Each card links straight to the store, and visitors can leave a "like" on the article they love most.',
  'boardsSection.cta': 'Create your board',
}

export const homeTranslations: Record<'it' | 'en', Record<TranslationKey, string>> = { it: italian, en: english }
